import React from "react";
import Layout from "../layout";
import FeaturesWithScreenshots from "../Components/home/FeaturesWithScreenshots";

export default function FeaturesTest() {
  return (
    <Layout currentPageName="Features Test">
      <div>
        {/* Notice Banner */}
        <div className="bg-gradient-to-r from-amber-500 to-orange-500 text-white py-4 px-4 text-center">
          <p className="font-semibold">
            ⚠️ TEST PAGE - This is a preview of the new Features section with screenshots
          </p>
          <p className="text-sm mt-1 opacity-90">
            If you like it, we can replace the current Features component. Your original is safe!
          </p>
        </div>
        <FeaturesWithScreenshots />
      </div>
    </Layout>
  );
}



